export default __webpack_public_path__ + "static/media/default_token_logo.af2dbd7c.svg";